<template>
  <Loved @click="toggle" v-if="active" class="hover:text-red-400 text-red-600 heart h-6 w-6 cursor-pointer" aria-hidden="false"/>
  <Unloved @click="toggle" v-else class="hover:text-very-red text-red-600 heart h-6 w-6 cursor-pointer" aria-hidden="false"/>
</template>

<script>
import {HeartIcon as Unloved} from '@heroicons/vue/outline';
import {HeartIcon as Loved} from '@heroicons/vue/solid'

export default {
  components: {
    Unloved,
    Loved
  },
  name: "FavoriteSession",
  computed: {
    classes() {
      return [
        'fa-heart',
        this.active ? 'fas' : 'far'
      ];
    },

    endpoint() {
      return '/session/' + this.session.id + '/favorite';
    }
  },
  props:
      {
        session: {
          type: Object,
          required: true
        },
        isFavorited: {
          type: Boolean,
          default: false,
          required: true
        }

      },

  data() {
    return {
      active: this.isFavorited
    }
  },
  setup(props) {

    const isActive = props.isFavorited;

    return {
      isActive
    }
  },

  methods: {
    toggle() {

      this.active ? this.destroy() : this.create();

    },

    create() {
      axios.post(this.endpoint);

      this.active = true;
      this.count++;
    },

    destroy() {
      axios.delete(this.endpoint);

      this.active = false;
      this.count--;
    }
  },

  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  beforeUnmount() {

  },
  unmounted() {

  }


};
</script>

<style scoped>
._heart {
  cursor: pointer;
  color: #e74444;
  font-size: 0.7em;
}
</style>